'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import posthog from 'posthog-js';

function PostHogPageView() {
  const pathname = usePathname();

  useEffect(() => {
    // Initialiser PostHog uniquement côté client
    if (typeof window !== 'undefined') {
      const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
      const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;

      if (posthogKey && posthogHost && !posthog.__loaded) {
        posthog.init(posthogKey, {
          api_host: posthogHost,
          // Mode sans cookies jusqu'à consentement explicite
          opt_out_capturing_by_default: true,
          // Activer le respect du consentement RGPD
          respect_dnt: true,
          // Ne pas capturer jusqu'à ce que l'utilisateur accepte explicitement
          loaded: (posthog) => {
            // Ne pas capturer automatiquement - attendre le consentement
            if (process.env.NODE_ENV === 'development') {
              posthog.debug();
            }
          },
        });
      }
    }
  }, []);

  useEffect(() => {
    // Tracker les changements de page
    if (pathname && typeof window !== 'undefined') {
      // Vérifier si PostHog est initialisé
      if (posthog && typeof posthog.capture === 'function') {
        const url = window.origin + pathname;
        posthog.capture('$pageview', {
          $current_url: url,
        });
      }
    }
  }, [pathname]);

  return null;
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <PostHogPageView />
      {children}
    </>
  );
}

